import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1acfa478")

_pushScopeId("data-v-1acfa478")
const _hoisted_1 = { class: "modal bg_grey d-flex justify-content-between align-items-center flex-column" }
const _hoisted_2 = { class: "page_padding text-center" }
const _hoisted_3 = { class: "page_padding w-100" }
const _hoisted_4 = { class: "text-center white fs_27 m-auto" }
const _hoisted_5 = { class: "page_padding d-flex w-100" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        type: "h3",
        class: "white text-uppercase text-center fw_700",
        localizedKey: "backoffice_Attenzione",
        text: "Attenzione"
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.infoText), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("button", {
        class: "secondaryButton w-50 me-1",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.denyCallback()))
      }, [
        _createVNode("span", null, _toDisplayString(_ctx.denyText), 1)
      ]),
      _createVNode("button", {
        class: "primaryButton w-50 ms-1",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.successCallback()))
      }, [
        _createVNode("span", null, _toDisplayString(_ctx.successText), 1)
      ])
    ])
  ]))
})